import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const getChatTagsByBusinessId = createAsyncThunk(
  'chatTags/getChatTagsByBusinessId',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;
      

      const response = await axios.get(
        `${ROOT_URL}/chat-tag/?business_id=${business_id}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  chatTags: [],
  loading: false,
  error: null
};

const getChatTagsByBusinessIdSlice = createSlice({
  name: 'getChatTagsByBusinessId',
  initialState,
  reducers: {
    resetChatTags: (state) => {
      state.chatTags = [];
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChatTagsByBusinessId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getChatTagsByBusinessId.fulfilled, (state, action) => {
        state.loading = false;
        state.chatTags = action.payload.data || [];
      })
      .addCase(getChatTagsByBusinessId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { resetChatTags } = getChatTagsByBusinessIdSlice.actions;
export default getChatTagsByBusinessIdSlice.reducer; 